<div class="pin-get-started">
    <div class="top-content text-center">
        <div class="vertically-centralized">
            <img alt="" class="mx-auto	my-0"
			src="../../../../../assets/images/svgs/business-pin.svg" srcset="">
        </div>
    </div>

    <div class="bottom-content text-center">
        <div class="title p-t-27">
            Before you continue...
        </div>
        <div class="sub-title">
			Setup your Business Pin
        </div>
        <div class="m-t-19">
            <div nz-row nzJustify="center">
                <div style="width: 100%;max-width: 335px">
                    <div class="kamona-button-session">
                        <app-kamona-custom-button
                        (submitForm)="submit()"
                        [isBlock]="true"
                        text="Continue">
                        </app-kamona-custom-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


